import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  login,
  register,
  logout,
  logoutAll,
  verifyEmail,
  resendVerificationEmail,
  requestPasswordReset,
  resetPassword,
} from "../api/auth";

export function useLogin() {
  return useMutation({
    mutationFn: ({
      email,
      password,
      extendedSession,
    }: {
      email: string;
      password: string;
      extendedSession: boolean;
    }) => login(email, password, extendedSession),
  });
}

export function useRegister() {
  return useMutation({
    mutationFn: ({
      email,
      password,
      name,
      currency,
      verificationCallbackUrl,
    }: {
      email: string;
      password: string;
      name: string;
      currency: string;
      verificationCallbackUrl: string;
    }) => register(email, password, name, currency, verificationCallbackUrl),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => logout(),
    onSuccess: () => {
      qc.clear(); // Clear all cached data on logout
    },
  });
}

export function useLogoutAll() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => logoutAll(),
    onSuccess: () => {
      qc.clear(); // Clear all cached data on logout
    },
  });
}

export function useVerifyEmail() {
  return useMutation({
    mutationFn: (token: string) => verifyEmail(token),
  });
}

export function useResendVerificationEmail() {
  return useMutation({
    mutationFn: ({
      email,
      verificationCallbackUrl,
    }: {
      email: string;
      verificationCallbackUrl: string;
    }) => resendVerificationEmail(email, verificationCallbackUrl),
  });
}

export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: ({
      email,
      callbackUrl,
    }: {
      email: string;
      callbackUrl: string;
    }) => requestPasswordReset(email, callbackUrl),
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: ({
      token,
      newPassword,
    }: {
      token: string;
      newPassword: string;
    }) => resetPassword(token, newPassword),
  });
}

